export enum Action {
  Provision = 'provision',
  ReAuth = 'reAuth',
}

export interface O365AuditLogBannerStatus {
  show: boolean;
  action: Action;
}
